import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Input } from '../input';
import { T } from '../t';
import { formatDate, parseIsoDate, validateDateFormat } from '../utils';
export const DateInput = ({ initialDate, onChange, onValidate, setValidateStatus, ...rest }) => {
    const formattedInitialDate = initialDate ? formatDate(initialDate, 'YYYY-MM-DD', { timeZone: 'UTC' }) : '';
    const [dateInput, setDateInput] = useState(formattedInitialDate);
    const [dateInputValidated, setDateInputValidated] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const isValidDate = (dateString) => {
        if (!validateDateFormat(dateString))
            return false;
        if (!parseIsoDate(dateString))
            return false;
        return true;
    };
    const handleOnBlur = () => {
        setDateInputValidated(!dateInput);
        const parsedDate = parseIsoDate(dateInput);
        if (parsedDate) {
            setDateInput(formatDate(parsedDate, 'YYYY-MM-DD', { timeZone: 'UTC' }));
            const validateMessage = onValidate(parsedDate);
            !validateMessage && onChange(parsedDate);
            setDateInputValidated(!validateMessage);
            setErrorMessage(validateMessage);
        }
    };
    useEffect(() => {
        setDateInput(formattedInitialDate);
        const validation = onValidate(initialDate);
        setDateInputValidated(!validation);
        setValidateStatus(!validation);
        setErrorMessage(validation);
    }, [initialDate]);
    useEffect(() => {
        if (dateInput) {
            const isValidDateString = isValidDate(dateInput);
            setValidateStatus(isValidDateString);
            if (!validateDateFormat(dateInput))
                setErrorMessage('Supported format is YYYY-MM-DD');
            else if (!parseIsoDate(dateInput))
                setErrorMessage('Invalid date');
            else {
                const parsedDate = parseIsoDate(dateInput);
                const validateMessage = onValidate(parsedDate);
                !validateMessage && onChange(parsedDate);
                setDateInputValidated(!validateMessage);
                setErrorMessage(validateMessage);
            }
        }
    }, [dateInput]);
    return (_jsx(Input, { borderColor: dateInputValidated ? 'sandstone.main' : 'energyRed.main', className: "dateInput", "data-testid": "test-date-input", errorText: !dateInputValidated && _jsx(T, { size: "md", children: errorMessage }), onBlur: handleOnBlur, onChange: e => setDateInput(e.target.value), placeholder: "YYYY-MM-DD", size: "md", state: !dateInputValidated && !errorMessage ? 'error' : 'default', value: dateInput, ...rest }));
};
